import React from 'react'; // { useEffect }
import styles from '../styles/Avaliacoes.module.css';

const Avaliacoes = () => {
  // useEffect(() => {
  //   const script = document.createElement('script');
  //   script.src = 'https://static.elfsight.com/platform/platform.js';
  //   script.async = true;
  //   document.body.appendChild(script);

  //   return () => {
  //     if (document.body.contains(script)) {
  //       document.body.removeChild(script);
  //     }
  //   };
  // }, []);

  return (
    <section className={styles.avaliacoes} id="avaliacoes">
      <div className={styles.container}>
        <h2 className={styles.title}>O Que Dizem Nossos Clientes</h2>
        
        <div className={styles.avaliacoesWidget}>
          {/* <div 
            className="elfsight-app-a85dd1de-e461-4e7f-9f35-71e991d1de0e" 
            data-elfsight-app-lazy
          ></div> */}
          <iframe title='Avaliações Paulo Ferreira e Maike Ramos' src="https://embedsocial.com/api/pro_hashtag/fa66aa7aec251549f6cc0cc6d93737113952a12f" width="100%" height="550px" frameborder="0" marginheight="0" marginwidth="0"></iframe>
        </div>
      </div>
    </section>
  );
};

export default Avaliacoes;